import React from "react";

import { useStore } from "../../Store";
import { Box } from "@chakra-ui/react";

interface SectionProps {
  isGrey?: boolean;
  isGreen?: boolean;
  hasPadding?: boolean;
  children: React.ReactNode;
}

export default function Section({
  children,
  isGrey = false,
  isGreen = false,
  hasPadding = true,
}: SectionProps) {
  const { loading } = useStore();

  const resolveBg = () => {
    const greyBackground = "#e4e4e4";
    const greenBackground = "#C6F6D5";
    let result = isGrey
      ? greyBackground
      : isGreen
      ? greenBackground
      : undefined;
    return result;
  };

  if (loading) {
    return null;
  }

  return (
    <Box px={hasPadding ? 5 : "0"} py={hasPadding ? 3 : "0"} bg={resolveBg()}>
      {children}
    </Box>
  );
}
